import { render } from "./type_create.vue?vue&type=template&id=93156520"
import script from "./type_create.vue?vue&type=script&lang=js"
export * from "./type_create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__